// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___3r86J","labelOff":"styles__labelOff___lzEoe styles__label___3r86J","container":"styles__container___fdz7n","value":"styles__value___A8GBp"};